const isMCOM = process.env.ENTRY_POINT === 'mcom';

/**
 * Handles color combinations for the fill color
 *
 * @param {String} theme
 * @param {Object} props
 * @param {String=} props.light
 * @param {String=} props.dark
 */
export function color(theme, props = {}) {
  const {
    light = '',
    dark = '',
  } = props;
  if (isMCOM) {
    return theme === 'light' ? light || 'white' : dark || 'black';
  }
  return theme === 'light' ? light || 'white' : dark || '#6E6E6E';
}

export function dimensions(size) {
  switch (size) {
  case 's':
    return 16;
  case 'l':
    return 32;
  case 'xl':
    return 48;
  case 'm':
  default:
    return 24;
  }
}
